import logo from '../../assets/images/bebrave-logo.svg';
import group from '../../assets/images/bebrave-group.svg';

import { UProfileMenu } from 'components/blocks/u-profile-menu';
import { useNavigate } from 'react-router-dom';
import { useSignatureResponse } from 'pages/hooks/use-home';
import { getAvailableApps, handleConfigItemClick} from 'pages/home/models/homeConfigs';
import { useTranslation } from 'react-i18next';
import { HomeDynamicHeader } from './components/HomeDynamicHeader';
import { useTheme } from 'components/core/theme-provider';
import { useCommonStore } from "state/store/common/useCommonStore";
import { useEffect, useState } from "react";

export default function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync } = useSignatureResponse();
  const { theme } = useTheme();
  const isAdmin = useCommonStore((state) => state.isAdmin);
  const [colSpan, setColSpan] = useState(2);

  useEffect(()=>{
    if (isAdmin) {
      setColSpan(3);
    }
  }, [isAdmin]);
  
  return (
    <div className="h-screen flex flex-col justify-between w-full">
      <header className="w-full flex px-6 py-4 items-center justify-between border-b border-gray-200">
        <div className="w-32 h-8 inline-flex justify-start items-center gap-1.5">
          <img
            className='w-8 h-8 relative overflow-hidden'
            src={logo}
            alt="bebrave logo"
          />
          <img
            className={`${theme === 'dark' ? 'invert' : ''}`}
            src={group}
            alt="bebrave group text"
          />
        </div>

        <div className="flex justify-between items-center gap-1 sm:gap-3 md:gap-4">
          <HomeDynamicHeader />
          <div className="border-l border-gray-300 h-4"></div>
          <UProfileMenu isDropdownIconRequired={true} isFullNameRequired={true} />
        </div>
      </header>

      <div className="flex flex-col items-center justify-center p-[2rem]">
        <div className="flex flex-col gap-8">
          <div className="justify-start text-neutral-500 text-2xl font-bold">{t('AVAILABLE_APPS')}</div>
          <div className={`grid grid-cols-1 sm:grid-cols-${isAdmin? 2 : 1} lg:grid-cols-${colSpan} xl:grid-cols-${colSpan} gap-6 mx-auto max-w-fit`}>
            { getAvailableApps(isAdmin)?.map((item, index) => (
              <div
                onClick={() => {
                  handleConfigItemClick(item, navigate, mutateAsync);
                }}
                key={index}
                className="w-[276px] flex flex-col items-center gap-4 px-6 pt-8 pb-6 bg-white hover:bg-primary group transition rounded-2xl shadow-all-sides-lg cursor-pointer"
              >
                <div className="w-16 h-16">
                  {item.icon}
                </div>
                <div className="self-stretch text-center justify-start text-neutral-500 group-hover:text-white transition duration-200 text-lg font-semibold leading-7 whitespace-nowrap overflow-hidden text-ellipsis">
                  {t(item.title)}
                </div>
                <div className="self-stretch text-center justify-start text-neutral-500 group-hover:text-white transition duration-200 text-sm font-normal leading-snug overflow-hidden line-clamp-2">
                  {t(item.description)}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}
